$(function () {
    // Packery.
    var $listItems = $(".list-items");
    $listItems.packery({
        itemSelector: ".item-container",
        gutter: 0
    });

    // Filter buttons.
    $(".list-filters button").click(function () {
        filterItemList(".list-items", $(this).attr("data-filter-value"));
        return false;
    });

    // Update filter based on history state on load.
    var filterClass = "*";

    if (window.history.state && window.history.state.filter) {
        filterClass = window.history.state.filter;
    } else if (window.location.hash.length > 1) {
        filterClass = window.location.hash.substr(1);
    }

    filterItemList(".list-items", filterClass);
});

function filterItemList(listContainer, filterClass) {
    // Get the filter group.
    var optionSet = $(".list-filters");

    // Remove current active, then add class to the clicked filter.
    optionSet.find(".active").removeClass("active");
    optionSet.find("[data-filter-value='" + filterClass + "']").addClass("active");

    // Hide all items
    $(listContainer + " .item-container").hide();

    // Show the items that match the selected filter
    $(listContainer + " .item-container" + filterClass).show();

    // Packery layout
    $(listContainer).packery();

    // Update href fragment.
    window.history.replaceState({
        filter: filterClass
    }, "", "#" + filterClass);
}
